import * as types from './types';

const INITIAL_STATE = {
  fetching: false,
  error: null,
  data: {},
  report: null,
  selectedHouseholds: [],
  writing: false,
};

export default (state = INITIAL_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case types.SELECTION_LETTERS_FETCH_ERROR:
      return { ...state, error: payload };
    case types.SELECTION_LETTERS_FETCHING:
      return { ...state, fetching: payload };
    case types.SELECTION_LETTERS_GET_DATA:
      return { ...state, data: payload };
    case types.SELECTION_LETTERS_GET_REPORT:
      return { ...state, report: payload };
    case types.SELECTION_LETTERS_SELECTED_HOUSEHOLDS:
      return { ...state, selectedHouseholds: payload };
    case types.SELECTION_LETTERS_WRITING_TO_DB:
      return { ...state, writing: payload };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/selectionletters/state/selectionletters/reducer.js